module.exports = __webpack_public_path__ + "img/chev_link.a18ee915.svg";